var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroDotsLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 109 25",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.969,
    cy: 20.757,
    r: 3.46,
    fill: "#FFF7F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.405,
    cy: 2.595,
    r: 2.595,
    fill: "#FFF7F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.896,
    cy: 2.595,
    r: 2.595,
    fill: "#FFF7F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.938,
    cy: 10.386,
    r: 1.73,
    fill: "#ACB5C2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.145,
    cy: 8.652,
    r: 1.73,
    fill: "#D4DAE1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.637,
    cy: 17.301,
    r: 1.73,
    fill: "#748499"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.73,
    cy: 12.113,
    r: 1.73,
    fill: "#ACB5C2"
  })));
}
export default __webpack_public_path__ + "fonts/hero-dots-left-f4a83528010051fa2aa988f290dc28c0.svg";
export { SvgHeroDotsLeft as ReactComponent };